import { forwardRef } from "react";
import aatLogo from "@/assets/aat-logo.png";
import xeroGoldPartner from "@/assets/xero-gold-partner.webp";
import sagePartner from "@/assets/sage-partner.webp";
import quickbooksProAdvisor from "@/assets/quickbooks-proadvisor.webp";
import freeagentPartner from "@/assets/freeagent-partner.webp";

const allBadges = [
  { src: aatLogo, alt: "AAT Licensed Accountant", title: "AAT Licensed", subtitle: "Accountant", key: "aat" },
  { src: xeroGoldPartner, alt: "Xero Gold Partner", title: "Xero Gold", subtitle: "Partner", key: "xero" },
  { src: sagePartner, alt: "Sage Business Partner", title: "Sage Business", subtitle: "Partner", key: "sage" },
  { src: quickbooksProAdvisor, alt: "QuickBooks ProAdvisor", title: "QuickBooks", subtitle: "ProAdvisor", key: "quickbooks" },
  { src: freeagentPartner, alt: "FreeAgent Partner", title: "FreeAgent", subtitle: "Partner", key: "freeagent" },
];

export const AccreditationBadges = forwardRef<HTMLDivElement, { compact?: boolean; only?: string[] }>(
  function AccreditationBadges({ compact = false, only }, ref) {
    const badges = only ? allBadges.filter((b) => only.includes(b.key)) : allBadges;
    if (compact) {
      return (
        <div ref={ref} className="flex flex-wrap items-center justify-center gap-6">
          {badges.map((badge) => (
            <div key={badge.alt} className="flex items-center gap-2.5">
              <div className="flex h-8 w-10 shrink-0 items-center justify-center">
                <img
                  src={badge.src}
                  alt={badge.alt}
                  className="max-h-8 max-w-[2.5rem] w-auto h-auto object-contain"
                />
              </div>
              <div>
                <p className="font-display text-xs font-semibold">{badge.title}</p>
                <p className="text-[10px] text-inherit opacity-80">{badge.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      );
    }

    return (
      <div ref={ref} className="flex flex-wrap items-center justify-center gap-6 md:gap-8">
        {badges.map((badge) => (
          <div
            key={badge.alt}
            className="flex w-[210px] items-center gap-4 rounded-xl border bg-card px-5 py-4"
          >
            <div className="flex h-12 w-14 shrink-0 items-center justify-center">
              <img
                src={badge.src}
                alt={badge.alt}
                className="max-h-12 max-w-[3.5rem] w-auto h-auto object-contain"
              />
            </div>
            <div className="min-w-0">
              <p className="font-display text-sm font-semibold leading-tight text-foreground">{badge.title}</p>
              <p className="text-xs text-muted-foreground">{badge.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    );
  }
);
AccreditationBadges.displayName = "AccreditationBadges";
